<script setup>
// BonBoZ: dau cot chi con o tim. Chon trang, sap xep va doi bo cuc da chuyen
// sang Bang dieu khien, giu lai o day chi la trung lap.
import { computed, ref } from 'vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  hasAppliedFilters: { type: Boolean, required: true },
  hasActiveFolders: { type: Boolean, required: true },
  // BonBoZ: có đúng một hộp thư Zalo thì hiện nút "Cuộc trò chuyện mới".
  coNutZalo: { type: Boolean, default: false },
});

const emit = defineEmits([
  'addFolders',
  'deleteFolders',
  'resetFilters',
  'filtersModal',
  'tim',
  'doiCheDoTim',
  'moZalo',
]);

// BonBoZ: hai tang tim, tach biet co y — xem `Conversations::SearchScope`.
//   'identity' — ten khach, so dien thoai, ma hoi thoai  (mac dinh)
//   'content'  — noi dung tin nhan
//
// Gop chung mot truy van thi go "tran" trung ca chu "tinh trang" trong tin
// nhan, ket qua loang den muc khong con dung de tim nguoi duoc nua.
const CHE_DO_TIM = [
  { gia: 'identity', nhan: 'BONBOZ.LOC.TIM_DANH_TINH' },
  { gia: 'content', nhan: 'BONBOZ.LOC.TIM_NOI_DUNG' },
];
const cheDoTim = ref('identity');
const doiCheDo = gia => {
  if (cheDoTim.value === gia) return;
  cheDoTim.value = gia;
  emit('doiCheDoTim', gia);
};

const dangLocRieng = computed(
  () => props.hasAppliedFilters || props.hasActiveFolders
);

const tuKhoa = ref('');
const goTim = event => {
  tuKhoa.value = event.target.value;
  emit('tim', tuKhoa.value);
};
</script>

<template>
  <!-- BonBoZ: cot danh sach de nen trang nhu Pancake, chi rail va navbar mau xanh. -->
  <div
    class="flex items-center gap-1 px-3 pt-2 pb-2 border-b border-n-weak bg-n-surface-1"
  >
    <NextButton
      v-if="coNutZalo"
      v-tooltip.bottom="$t('BONBOZ.CUOC_TRO_CHUYEN_MOI.NUT')"
      icon="i-lucide-square-pen"
      slate
      ghost
      sm
      class="shrink-0"
      @click="emit('moZalo')"
    />
    <!-- BonBoZ: go toi dau loc toi do, khong nhay sang trang tim kiem roi quay lai. -->
    <div class="flex flex-col flex-1 gap-1.5 min-w-0">
      <div class="relative">
        <i
          class="absolute i-lucide-search size-4 text-n-slate-10 ltr:left-2.5 rtl:right-2.5 top-2"
          aria-hidden="true"
        />
        <input
          :value="tuKhoa"
          type="search"
          :placeholder="$t('BONBOZ.LOC.TIM')"
          class="reset-base w-full !h-8 !m-0 ltr:!pl-8 rtl:!pr-8 !pr-2 !text-sm !leading-8 !bg-n-slate-3 !rounded-full !outline-0 text-n-slate-12 placeholder:text-n-slate-10 focus-visible:ring-2 focus-visible:ring-n-brand"
          @input="goTim"
        />
      </div>
      <!-- Chi hien khi dang go: cot hep, khong de chiem cho luc khong dung. -->
      <div v-if="tuKhoa" class="flex gap-1">
        <button
          v-for="muc in CHE_DO_TIM"
          :key="muc.gia"
          type="button"
          class="px-2 py-0.5 text-xs rounded-full"
          :class="
            cheDoTim === muc.gia
              ? 'bg-n-slate-4 text-n-slate-12 font-medium'
              : 'text-n-slate-10'
          "
          @click="doiCheDo(muc.gia)"
        >
          {{ $t(muc.nhan) }}
        </button>
      </div>
    </div>

    <div v-if="dangLocRieng" class="flex items-center gap-1 shrink-0">
      <!-- Đang mở bộ lọc/thư mục lưu sẵn thì vẫn cần nút lưu, sửa, xoá -->
      <template v-if="hasAppliedFilters && !hasActiveFolders">
        <div class="relative">
          <NextButton
            v-tooltip.top-end="$t('FILTER.CUSTOM_VIEWS.ADD.SAVE_BUTTON')"
            icon="i-lucide-save"
            slate
            xs
            faded
            @click="emit('addFolders')"
          />
          <div id="saveFilterTeleportTarget" class="absolute z-50 mt-2" />
        </div>
        <NextButton
          v-tooltip.top-end="$t('FILTER.CLEAR_BUTTON_LABEL')"
          icon="i-lucide-circle-x"
          ruby
          faded
          xs
          @click="emit('resetFilters')"
        />
      </template>
      <template v-if="hasActiveFolders">
        <div class="relative">
          <NextButton
            id="toggleConversationFilterButton"
            v-tooltip.top-end="$t('FILTER.CUSTOM_VIEWS.EDIT.EDIT_BUTTON')"
            icon="i-lucide-pen-line"
            slate
            xs
            faded
            @click="emit('filtersModal')"
          />
          <div
            id="conversationFilterTeleportTarget"
            class="absolute z-50 mt-2"
          />
        </div>
        <NextButton
          v-tooltip.top-end="$t('FILTER.CUSTOM_VIEWS.DELETE.DELETE_BUTTON')"
          icon="i-lucide-trash-2"
          ruby
          xs
          faded
          @click="emit('deleteFolders')"
        />
      </template>
    </div>
  </div>
</template>
